﻿import { DropdownMenu } from '../toolkit';
import TranslatorManager from 'ts-translate-js';
import cIf from 'classnames';
import { concatUrl } from '../util';

const tr = TranslatorManager.boundTR;

const React = require('react');
const PT = require('prop-types');

// The login control in the menu bar
export class UserSessionInfoWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            profile: this.props.profile, // Because we need to support overrides
            isAuthenticated: this.props.isAuthenticated
        };
        this.handleLogin = this.handleLogin.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleGotoProfile = this.handleGotoProfile.bind(this);
        this.handleGotoRegistration = this.handleGotoRegistration.bind(this);
        this.handleGotoOrderHistory = this.handleGotoOrderHistory.bind(this);

    }

    componentDidMount(){
        if (!this.props.isInMaintenance) {
        // Listenin to account change (login, name change...) from integration here
        if(tsapp.integrationEventsEmitter) tsapp.integrationEventsEmitter.on('onAccountChange', this.onAccountChange.bind(this));

        // This works only one time. That will be it for the moment.
        if(!this.props.profile)
            this.loadProfile();
        }
    }

    componentWillUnmount() {
        // Unsubscribing from custom events
        tsapp.integrationEventsEmitter.off('onAccountChange', this.onAccountChange.bind(this));

        if(this.profileRequest) this.profileRequest.abort();
        //if(this.urls) this.urls.abort();
    }

    onAccountChange() {
        // this.setState({isAuthenticated: payload.isAuthenticated});
        this.loadProfile();
    }
    
    loadProfile(){
        this.profileRequest = tsapp.mvcapi.postCtl("profile/ProfileInfo")
                                   .success(function(data){
                                       this.setState({ profile: data.profile });
                                   }.bind(this))
        // eslint-disable-next-line lodash/prefer-noop
                                   .notSuccess(function(){
                                       // TODO: What do we hate to do here?
                                   }.bind(this));
    }

    handleLogin() {
        let baseUrl = this.props.homeUrl;
        if (tsapp.isLiteShop) {
            baseUrl = concatUrl(baseUrl, tsapp.shopBasePath);
        }
        parent.location.href = concatUrl(baseUrl, "login");
        //this.urls.then((url) => parent.location.href = url.LoginUrl, (err) => console.log(err)).catch(err => console.log(err));
    }

    handleGotoProfile() {
        let baseUrl = this.props.homeUrl;
        if (tsapp.isLiteShop) {
            baseUrl = concatUrl(baseUrl, tsapp.shopBasePath);
        }
        parent.location.href = concatUrl(baseUrl, "profile");
        //this.urls.then((url) => parent.location.href = url.ProfileUrl, (err) => console.log(err)).catch(err => console.log(err));
    }
    handleGotoRegistration() {
        let baseUrl = this.props.homeUrl;
        if (tsapp.isLiteShop) {
            baseUrl = concatUrl(baseUrl, tsapp.shopBasePath);
        }
        parent.location.href = concatUrl(baseUrl, "register");
        //this.urls.then((url) => parent.location.href = url.RegisterUrl, (err) => console.log(err)).catch(err => console.log(err));
    }

    handleGotoOrderHistory() {
        let baseUrl = this.props.homeUrl;
        if (tsapp.isLiteShop) {
            baseUrl = concatUrl(baseUrl, tsapp.shopBasePath);
        }
        parent.location.href = concatUrl(baseUrl, "/profile/orders"); // Don't know if it really need to go in the urls. I think we'll see later for this one.
    }

    
    handleLogout() {
        tsapp.logout().success(() => { tsapp.goToHome(this.props.integ); });
    }

    haveIdentificationName() {
        return this.state.profile != undefined && (this.state.profile.FirstName != "" && this.state.profile.LastName != "");
    }

    render() {
        return <div className={cIf(["user-session-info-widget", { "is-logged": this.haveIdentificationName() }])}>
            <UserSessionInfoWidget_View1
                profile={this.state.profile}
                isAuthenticated={this.haveIdentificationName()}
                loginClick={this.handleLogin}
                logoutClick={this.handleLogout}
                profileClick={this.handleGotoProfile}
                registerClick={this.handleGotoRegistration}
                ordersClick={this.handleGotoOrderHistory}
            />
            {
                this.haveIdentificationName() && this.props.displayHello ?
                <div className="username">{tr("Bonjour")} {this.state.profile.FirstName}!</div>
                : null
            }
        </div>;
    }
}
UserSessionInfoWidget.propTypes = {
    integ: PT.string.isRequired,
    homeUrl: PT.string,
    profile: PT.shape({
        FirstName: PT.string,
        LastName: PT.string
    }),
    isAuthenticated: PT.bool,
    isInMaintenance: PT.bool,
    displayHello: PT.bool,
};
UserSessionInfoWidget.defaultProps = {
    supportedLangs: [ 'fr-CA', 'en-CA' ],
    displayHello: true
};


// Views prop types
const UserSessionInfoWidget_View_PropTypes = {
    profile: PT.shape({ // Based on the profile object, here you tell what you need from it.
        FirstName: PT.string,
        LastName: PT.string
    }),
    isAuthenticated: PT.bool,
    loginClick: PT.func,
    logoutClick: PT.func,
    profileClick: PT.func,
    ordersClick: PT.func,
    registerClick: PT.func
};

// IS3 view
export function UserSessionInfoWidget_View1(props) {
    let items = [];
    if(props.isAuthenticated) {
        if (props.profile)
            items.push({ label: `${props.profile.FirstName} ${props.profile.LastName}` }); // Maybe we need to add a "class" property here
        items.push({ label: tr("Mon profil"), onClick: props.profileClick });
        items.push({ label: tr("Mes commandes"), onClick: props.ordersClick });
        items.push({ label: tr("Me déconnecter"), onClick: props.logoutClick });
    } else {
        items.push({ label: tr("Me connecter"), onClick: props.loginClick });
        items.push({ label: tr("M'enregistrer"), onClick: props.registerClick });
    }
    
    return (
        <div>
            <DropdownMenu
                items={items}
                menuStyle={{width: 185}} // we should move this to a CSS class
                useIcon={true}
                icon={{ className: "fas fa-user-circle", tooltip: (props.isAuthenticated ? tr("Votre compte") : tr("Connectez-vous")) }}/>
        </div>
    );
}
UserSessionInfoWidget_View1.propTypes = UserSessionInfoWidget_View_PropTypes;


